/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('popup-picker', {
    attrs: {
      "columns": _vm.columns,
      "show-name": "",
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "title": _vm.title,
      "show": _vm.show,
      "data": _vm.data.map(_vm.format)
    },
    on: {
      "on-hide": function ($event) {
        return _vm.$emit('on-hide', $event);
      },
      "on-change": function ($event) {
        return _vm.$emit('on-change', $event);
      }
    },
    model: {
      value: _vm.copyValue,
      callback: function ($$v) {
        _vm.copyValue = $$v;
      },
      expression: "copyValue"
    }
  }, [_vm._t("title", null, {
    "slot": "title"
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };